import AdebifyCustomReportReducer from './reducers';

export default AdebifyCustomReportReducer;
